import { render, staticRenderFns } from "./GeneralSelect.vue?vue&type=template&id=3c2f07d1&"
import script from "./GeneralSelect.vue?vue&type=script&lang=js&"
export * from "./GeneralSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GeneralSelect.vue"
export default component.exports